module.exports = __webpack_public_path__ + "img/thumbnail_CloudlessSulphur_u_normal.93c6cfdf.png";